import type { MightierSupportedLanguage } from "@typings/mightierApiTypes";

export const languageOptions: {
  value: MightierSupportedLanguage;
  label: string;
}[] = [
  { value: "en", label: "English" },
  { value: "es", label: "Español" },
  { value: "fr-CA", label: "Français (Canada)" },
  { value: "ar", label: "عربي" },
  { value: "ru", label: "Русский" },
  { value: "uk", label: "Українська" },
  { value: "vi", label: "Tiếng Việt" },
  { value: "zh-CN", label: "中文（简体）" },
];

export const DEFAULT_LANGUAGE_OPTION = "en";
